<template>
    <van-popup v-model:show="show" position="right" :style="{
        minWidth: '100%',
        minHeight: '100%',
        background: 'green',
        color: '#fff',
        overflow: 'hidden',
    }">
        <div class="popupContainer">
            <CustomHeader :text="$t('common.history')" :isPopupCloseBackIcon="true" @closePopup="close" />
            <div class="historyContainer" v-if="!isUseFirstRecharge">
                <NoData v-if="historyList.length <= 0" />
                <CashBackHistoryCard v-for="(item, index) in historyList" :key="index" :isShowDetails="false"
                    :createTime="item.createTime ?? item.lossDate" :day-count="item.dayCount ?? item.day" :title="title"
                    :activity-status="item.status" :given-amount="item.givenAmount ?? item.claimGiftAmount"
                    :total-amount="item.totalBetAmount ?? item.rechargeTotal ?? item.totalBetLoss"
                    :available-amount="item.remainGiftAmount ?? item.availableAmount"
                    :day-list="convertStringToArray(item.dayRewards)" :isShowTodayHighlight="false" />
                <van-row v-if="isShowMore">
                    <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png" alt=""
                            @click="getNextPageRewardData"></van-col>
                </van-row>
            </div>

            <div class="historyContainer" v-if="isUseFirstRecharge">
                <NoData v-if="historyList.length <= 0" />
                <DayList v-for="(i, index) in historyList" :key="index" :currenyLable="true" :valueOne="i?.coin" :isShowHistory="true"
                    :valueTwo="i?.turnover" :labelOne="'dayList.giftAmount'" :labelTwo="'dayList.turnoverTimes'"
                    :activityStatus="i?.status" :time="i?.rewardDate" :available-amount="i?.availableAmount"
                    :given-amount="i?.givenAmount" />
                <van-row v-if="isShowMore">
                    <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png" alt=""
                            @click="getNextPageRewardData"></van-col>
                </van-row>
            </div>
        </div>

    </van-popup>
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref, defineExpose, defineEmits, PropType, computed, defineProps } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import CustomHeader from '../../components/common/customHeader.vue';
import CashBackHistoryCard from './cashBackHistoryCard.vue';
import NoData from '../../components/common/noData.vue';
import { convertStringToArray } from '@/utils/commonFunction';
import DayList from '../../components/common/dayList.vue';

const props = defineProps({
    list: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    showIcon: {
        type: Boolean
    },
    title: String,
    isUseFirstRecharge: {
        type: Boolean,
        default: () => false
    }
})
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const isShowMore = computed(() => props.showIcon)
const historyList = computed(() => props.list)

const loadingRef = ref()
const emits = defineEmits(["getHistoryList", 'updateHistoryList', 'resetHistoryData'])

const open = () => {
    show.value = true
    emits('getHistoryList')
}

const close = () => {
    show.value = false
    emits('resetHistoryData')
}

const getNextPageRewardData = () => {
    emits('updateHistoryList')
}

defineExpose({
    open,
    close
})
</script>
<style scoped>
.popupContainer {
    background: url('@/assets/main_bg.png');
    background-size: cover;
    background-repeat: repeat;
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

.historyContainer {
    padding: 50px 15px;
    height: calc(100vh - 50px);
    overflow-y: auto;
    box-sizing: border-box;
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin-top: 5px;
}

.historyContainer::-webkit-scrollbar {
    display: none;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 25px;
    transform: rotate(-90deg);
    padding: 10px;
}
</style>